/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useReducer } from "react";
import { Form, FormGroup, ListGroup, ListGroupItem, Label, Input, Button } from "reactstrap";
import PropTypes from "prop-types";

import {
  PhysicalPersonRelationshipAccount,
  PhysicalPersonRelationshipAccountJuridical,
} from "../Person/types";
import { PersonType } from "./types";
import { SelectFormField } from "../../../utils/FormFields";
import { AccountMode } from "../../../utils/Helper";
import translate from "../../../utils/Translator";

const HoldersForm = ({
  holders,
  changedHolder,
  collapsedHolder,
  toggleHolder,
  onChange,
  account,
  existsMainHolder,
  handleDeleteHolder,
  role,
  isReadOnly,
  Link,
  mode,
}) => {
  const handleChangeInstruction = (name, value, index) => {
    onChange(index, name, value === "1");
  };

  const [isPhysicalAccount, setPhysical] = useState(account.AccountIsPhysical);

  const onChangePhysical = (value) => {
    setPhysical(value === "1");
  };

  return (
    <Form>
      <FormGroup tag="fieldset">
        <ListGroup>
          {holders.map((holder, index) => {
            const holderId = holder.AccountHolderId;
            const isMainHolder = changedHolder[holderId]
              ? changedHolder[holderId].isMainHolder
              : holder.IsMainHolder;
            const canBeMainHolder = (!existsMainHolder && !isMainHolder) || isMainHolder;
            const holderRelationshipJuridical = changedHolder[holderId]
              ? changedHolder[holderId].HoldersRelationshipJuridical
              : holder.AccountHolderRelationshipJuridical;
            const isController = changedHolder[holderId]
              ? changedHolder[holderId].HoldersIsController
              : holder.AccountHolderIsController;
            const isManager = changedHolder[holderId]
              ? changedHolder[holderId].HoldersIsManager
              : holder.AccountHolderIsManager;
            const accountRelationship = changedHolder[holderId]
              ? changedHolder[holderId].HoldersRelationship
              : holder.AccountHolderRelationship;
            const instructions = changedHolder[holderId]
              ? {
                  HoldersOrderManaged: changedHolder[holderId].HoldersOrderManaged,
                  HoldersOrderWeb: changedHolder[holderId].HoldersOrderWeb,
                  HoldersOrderWritten: changedHolder[holderId].HoldersOrderWritten,
                  HoldersOrderViaLink: changedHolder[holderId].HoldersOrderViaLink,
                }
              : {
                  HoldersOrderManaged: holder.HoldersOrderManaged,
                  HoldersOrderWeb: holder.HoldersOrderWeb,
                  HoldersOrderWritten: holder.HoldersOrderWritten,
                  HoldersOrderViaLink: holder.HoldersOrderViaLink,
                };

            return (
              <React.Fragment key={holderId}>
                <ListGroupItem
                  onClick={() => toggleHolder(index, true)}
                  style={{ cursor: "pointer", marginTop: 5, backgroundColor: "#607d8b" }}
                >
                  <Label
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      display: "block",
                    }}
                  >
                    {isPhysicalAccount
                      ? holder.AccountHolderName +
                        " - " +
                        holder.AccountHolderDocumentTypeName +
                        " - " +
                        holder.AccountHolderDocumentNumber +
                        " - " +
                        holder.AccountHolderRelationship +
                        " " +
                        (holder.IsMainHolder ? "(Main Holder)" : "")
                      : holder.AccountHolderName +
                        " - " +
                        holder.AccountHolderDocumentTypeName +
                        " - " +
                        holder.AccountHolderDocumentNumber +
                        " - " +
                        holder.AccountHolderRelationshipJuridical +
                        " " +
                        (holder.IsMainHolder ? "(Main Holder)" : "")}
                    <div style={{ float: "right" }}>
                      {collapsedHolder[index].open ? (
                        <i className="fa fa-chevron-down" />
                      ) : (
                        <i className="fa fa-chevron-right" />
                      )}
                    </div>
                  </Label>
                </ListGroupItem>
                {collapsedHolder[index].open && (
                  <ListGroupItem>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                        {role == "Beneficiary" ? "Beneficiary" : "Holder"} Name:
                      </Label>
                      <Input value={holder.AccountHolderName} readOnly />
                    </FormGroup>
                    <React.Fragment>
                      {existsMainHolder ? (
                        isPhysicalAccount ? (
                          <React.Fragment>
                            <FormGroup>
                              <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                {translate("Account")} Relationship:
                                {!isReadOnly && (
                                  <div style={{ marginLeft: 10 }} onClick={() => toggleHolder(index, false)}>
                                    {collapsedHolder[index].canEdit ? (
                                      <i className="fa fa-unlock" />
                                    ) : (
                                      <i className="fa fa-lock" />
                                    )}
                                  </div>
                                )}
                              </Label>
                              <Input
                                type="select"
                                disabled={!collapsedHolder[index].canEdit}
                                onChange={(e) => onChange(index, "HoldersRelationship", e.target.value)}
                                value={accountRelationship}
                              >
                                {Object.keys(PhysicalPersonRelationshipAccount).map((key) => {
                                  if (
                                    isMainHolder &&
                                    PhysicalPersonRelationshipAccount[key] ===
                                      PhysicalPersonRelationshipAccount.Attorney
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <option key={key} value={key}>
                                      {PhysicalPersonRelationshipAccount[key]}
                                    </option>
                                  );
                                })}
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                is Main Holder:
                                <Input
                                  type="checkbox"
                                  style={{ marginLeft: 10 }}
                                  disabled={
                                    !collapsedHolder[index].canEdit ||
                                    !canBeMainHolder ||
                                    accountRelationship === PhysicalPersonRelationshipAccount.Attorney
                                  }
                                  defaultChecked={isMainHolder}
                                  value={isMainHolder}
                                  onClick={() => onChange(index, "isMainHolder", !isMainHolder)}
                                />
                              </Label>
                            </FormGroup>
                            {holder.AccountHolderPersonType == PersonType.Physical && (
                              <FormGroup>
                                <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                  is Beneficiary:
                                  <Input
                                    type="checkbox"
                                    style={{ marginLeft: 10 }}
                                    disabled={!collapsedHolder[index].canEdit}
                                    defaultChecked={holder.AccountHolderIsBeneficiary}
                                    value={holder.AccountHolderIsBeneficiary}
                                    onClick={() =>
                                      onChange(
                                        index,
                                        "AccountHolderIsBeneficiary",
                                        !holder.AccountHolderIsBeneficiary
                                      )
                                    }
                                  />
                                </Label>
                              </FormGroup>
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <FormGroup>
                              <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                {translate("Account")} Relationship Juridical:
                                {!isReadOnly && (
                                  <div style={{ marginLeft: 10 }} onClick={() => toggleHolder(index, false)}>
                                    {collapsedHolder[index].canEdit ? (
                                      <i className="fa fa-unlock" />
                                    ) : (
                                      <i className="fa fa-lock" />
                                    )}
                                  </div>
                                )}
                              </Label>
                              <Input
                                type="select"
                                disabled={!collapsedHolder[index].canEdit}
                                onChange={(e) =>
                                  onChange(index, "HoldersRelationshipJuridical", e.target.value)
                                }
                                value={
                                  changedHolder[holderId]
                                    ? changedHolder[holderId].HoldersRelationshipJuridical
                                    : holder.AccountHolderRelationshipJuridical
                                }
                              >
                                {Object.keys(PhysicalPersonRelationshipAccountJuridical).map((key) => (
                                  <option key={key} value={key}>
                                    {PhysicalPersonRelationshipAccountJuridical[key]}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                is Main Holder:
                                <Input
                                  type="checkbox"
                                  style={{ marginLeft: 10 }}
                                  disabled={
                                    !collapsedHolder[index].canEdit ||
                                    !canBeMainHolder ||
                                    holder.AccountHolderPersonType === "Physical"
                                  }
                                  defaultChecked={isMainHolder}
                                  value={isMainHolder}
                                  onClick={() => onChange(index, "isMainHolder", !isMainHolder)}
                                />
                              </Label>
                            </FormGroup>

                            <FormGroup>
                              <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                Holder is Controller:
                                <Input
                                  type="checkbox"
                                  style={{ marginLeft: 10 }}
                                  disabled={!collapsedHolder[index].canEdit}
                                  value={holder.AccountHolderIsController}
                                  defaultChecked={holder.AccountHolderIsController}
                                  onChange={() =>
                                    onChange(index, "HoldersIsController", !holder.AccountHolderIsController)
                                  }
                                />
                              </Label>
                            </FormGroup>
                            <FormGroup>
                              <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                Holder is Manager:
                                <Input
                                  type="checkbox"
                                  style={{ marginLeft: 10 }}
                                  disabled={!collapsedHolder[index].canEdit}
                                  value={holder.AccountHolderIsManager}
                                  defaultChecked={holder.AccountHolderIsManager}
                                  onChange={() =>
                                    onChange(index, "HoldersIsManager", !holder.AccountHolderIsManager)
                                  }
                                />
                              </Label>
                            </FormGroup>
                          </React.Fragment>
                        )
                      ) : (
                        <React.Fragment>
                          <SelectFormField
                            label={`${translate("Account")} is physical?: `}
                            value={isPhysicalAccount ? "1" : "0"}
                            selectItems={[1, 0]}
                            getSelectItemId={(i) => i}
                            getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                            disabled={existsMainHolder}
                            name="isphysical"
                            onChange={(name, value) => onChangePhysical(value)}
                          />

                          {isPhysicalAccount ? (
                            <React.Fragment>
                              <FormGroup>
                                <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                  {translate("Account")} Relationship:
                                  {!isReadOnly && (
                                    <div
                                      style={{ marginLeft: 10 }}
                                      onClick={() => toggleHolder(index, false)}
                                    >
                                      {collapsedHolder[index].canEdit ? (
                                        <i className="fa fa-unlock" />
                                      ) : (
                                        <i className="fa fa-lock" />
                                      )}
                                    </div>
                                  )}
                                </Label>
                                <Input
                                  type="select"
                                  disabled={!collapsedHolder[index].canEdit}
                                  onChange={(e) => onChange(index, "HoldersRelationship", e.target.value)}
                                  value={accountRelationship}
                                >
                                  {Object.keys(PhysicalPersonRelationshipAccount).map((key) => {
                                    if (
                                      isMainHolder &&
                                      PhysicalPersonRelationshipAccount[key] ===
                                        PhysicalPersonRelationshipAccount.Attorney
                                    ) {
                                      return null;
                                    }
                                    return (
                                      <option key={key} value={key}>
                                        {PhysicalPersonRelationshipAccount[key]}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </FormGroup>
                              <FormGroup>
                                <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                  is Main Holder:
                                  <Input
                                    type="checkbox"
                                    style={{ marginLeft: 10 }}
                                    disabled={
                                      !collapsedHolder[index].canEdit || !canBeMainHolder
                                      //|| holder.AccountHolderPersonType === "Physical"
                                    }
                                    defaultChecked={isMainHolder}
                                    value={isMainHolder}
                                    onClick={() => onChange(index, "isMainHolder", !isMainHolder)}
                                  />
                                </Label>
                              </FormGroup>
                              {holder.AccountHolderPersonType == "Physical" && (
                                <FormGroup>
                                  <Label
                                    check
                                    style={{ fontWeight: 500, fontSize: "15px", display: "block" }}
                                  >
                                    is Beneficiary:
                                    <Input
                                      type="checkbox"
                                      style={{ marginLeft: 10 }}
                                      disabled={!collapsedHolder[index].canEdit}
                                      defaultChecked={holder.AccountHolderIsBeneficiary}
                                      value={holder.AccountHolderIsBeneficiary}
                                      onClick={() =>
                                        onChange(
                                          index,
                                          "AccountHolderIsBeneficiary",
                                          !holder.AccountHolderIsBeneficiary
                                        )
                                      }
                                    />
                                  </Label>
                                </FormGroup>
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <FormGroup>
                                <Label style={{ fontWeight: 500, fontSize: "15px", display: "flex" }}>
                                  {translate("Account")} Relationship Juridical:
                                  {!isReadOnly && (
                                    <div
                                      style={{ marginLeft: 10 }}
                                      onClick={() => toggleHolder(index, false)}
                                    >
                                      {collapsedHolder[index].canEdit ? (
                                        <i className="fa fa-unlock" />
                                      ) : (
                                        <i className="fa fa-lock" />
                                      )}
                                    </div>
                                  )}
                                </Label>
                                {!isReadOnly && (
                                  <Input
                                    type="select"
                                    disabled={!collapsedHolder[index].canEdit}
                                    onChange={(e) =>
                                      onChange(index, "HoldersRelationshipJuridical", e.target.value)
                                    }
                                    value={
                                      changedHolder[holderId]
                                        ? changedHolder[holderId].HoldersRelationshipJuridical
                                        : holder.AccountHolderRelationshipJuridical
                                    }
                                  >
                                    {Object.keys(PhysicalPersonRelationshipAccountJuridical).map((key) => (
                                      <option key={key} value={key}>
                                        {PhysicalPersonRelationshipAccountJuridical[key]}
                                      </option>
                                    ))}
                                  </Input>
                                )}
                              </FormGroup>
                              <FormGroup>
                                <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                  is Main Holder:
                                  <Input
                                    type="checkbox"
                                    style={{ marginLeft: 10 }}
                                    disabled={
                                      holder.AccountHolderPersonType === "Physical" ||
                                      holderRelationshipJuridical != "Holder"
                                    }
                                    defaultChecked={isMainHolder || holderRelationshipJuridical == "Holder"}
                                    value={isMainHolder || holderRelationshipJuridical == "Holder"}
                                    onClick={() => onChange(index, "isMainHolder", !isMainHolder)}
                                  />
                                </Label>
                              </FormGroup>
                              <FormGroup>
                                <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                  Holder is Controller:
                                  <Input
                                    type="checkbox"
                                    style={{ marginLeft: 10 }}
                                    disabled={!collapsedHolder[index].canEdit}
                                    value={holder.AccountHolderIsController}
                                    defaultChecked={holder.AccountHolderIsController}
                                    onChange={() =>
                                      onChange(
                                        index,
                                        "HoldersIsController",
                                        !holder.AccountHolderIsController
                                      )
                                    }
                                  />
                                </Label>
                              </FormGroup>
                              <FormGroup>
                                <Label check style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>
                                  Holder is Manager:
                                  <Input
                                    type="checkbox"
                                    style={{ marginLeft: 10 }}
                                    disabled={!collapsedHolder[index].canEdit}
                                    value={holder.AccountHolderIsManager}
                                    defaultChecked={holder.AccountHolderIsManager}
                                    onChange={() =>
                                      onChange(index, "HoldersIsManager", !holder.AccountHolderIsManager)
                                    }
                                  />
                                </Label>
                              </FormGroup>
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                    {/* <FormGroup>
                        <Label check style={{ fontWeight: 500, fontSize: '15px', display: 'block' }}>
                        Deposit Authorization:
                        <Input type="checkbox" style={{ marginLeft: 10 }} disabled={!collapsedHolder[index].canEdit} defaultChecked={holder.AccountHolderAssigneeDeposit} value={holder.AccountHolderAssigneeDeposit} onClick={() => onChange(index, 'AccountHolderAssigneeDeposit',event.target.checked)} />
                        </Label>
                      </FormGroup>
                      <FormGroup>
                        <Label check style={{ fontWeight: 500, fontSize: '15px', display: 'block' }}>
                        Withdraw Authorization:
                        <Input type="checkbox" style={{ marginLeft: 10 }} disabled={!collapsedHolder[index].canEdit} defaultChecked={holder.AccountHolderAssigneeWithdraw} value={holder.AccountHolderAssigneeWithdraw} onClick={() => onChange(index, 'AccountHolderAssigneeWithdraw', event.target.checked)} />
                      
                        </Label>
                      </FormGroup> */}
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Email:</Label>
                      <Input disabled value={holder.AccountHolderEmail} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Phone:</Label>
                      <Input disabled value={holder.AccountHolderTel} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Address:</Label>
                      <Input disabled value={holder.AccountHolderAddress} readOnly />
                    </FormGroup>
                    <FormGroup>
                      <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>Country:</Label>
                      <Input disabled value={holder.AccountHolderCountryName} readOnly />
                    </FormGroup>
                    {account.AccountWayGiveOrders === "Managed" && (
                      <SelectFormField
                        label="Authorization Managed: "
                        value={instructions.HoldersOrderManaged ? "1" : "0"}
                        selectItems={[1, 0]}
                        disabled={account.AccountWayGiveOrders === "Managed"}
                        getSelectItemId={(i) => i}
                        getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                        name="HoldersOrderManaged"
                        onChange={(name, value) => handleChangeInstruction(name, value, index)}
                      />
                    )}

                    {account.AccountWayGiveOrders === "Written" && (
                      <div>
                        {!isReadOnly && (
                          <SelectFormField
                            label="Authorization Written: "
                            value={instructions.HoldersOrderWritten ? "1" : "0"}
                            selectItems={[1, 0]}
                            getSelectItemId={(i) => i}
                            getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                            name="HoldersOrderWritten"
                            onChange={(name, value) => handleChangeInstruction(name, value, index)}
                          />
                        )}
                        {!isReadOnly && (
                          <SelectFormField
                            label="Authorization Web: "
                            value={instructions.HoldersOrderWeb ? "1" : "0"}
                            selectItems={[1, 0]}
                            getSelectItemId={(i) => i}
                            getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                            disabled={instructions.HoldersOrderManaged}
                            name="HoldersOrderWeb"
                            onChange={(name, value) => handleChangeInstruction(name, value, index)}
                          />
                        )}
                        {!isReadOnly && (
                          <SelectFormField
                            label="Authorization Via Link: "
                            value={instructions.HoldersOrderViaLink ? "1" : "0"}
                            selectItems={[1, 0]}
                            getSelectItemId={(i) => i}
                            getSelectItemName={(i) => (i === 1 ? "Yes" : "No")}
                            disabled={instructions.HoldersOrderManaged}
                            name="HoldersOrderViaLink"
                            onChange={(name, value) => handleChangeInstruction(name, value, index)}
                          />
                        )}
                      </div>
                    )}
                    <React.Fragment>
                      {!isReadOnly && (
                        <FormGroup>
                          <Label style={{ fontWeight: 500, fontSize: "15px", display: "block" }}>PEP?:</Label>
                          <Input value={holder.PEP ? "Yes" : "No"} />
                        </FormGroup>
                      )}
                      {!isReadOnly && (
                        <Button
                          disabled={isMainHolder && isPhysicalAccount}
                          onClick={() => handleDeleteHolder(holderId)}
                        >
                          <i className="fa fa-trash" />
                          Remove Holder
                        </Button>
                      )}
                    </React.Fragment>

                    {!isReadOnly && holder.AccountHolderStatus === "Inactive" && (
                      <Link to={`/editperson/${account.AccountId}/${holderId}`}>
                        Edit Person
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                      </Link>
                    )}
                  </ListGroupItem>
                )}
              </React.Fragment>
            );
          })}
        </ListGroup>
      </FormGroup>
    </Form>
  );
};

HoldersForm.propTypes = {
  holders: PropTypes.array.isRequired,
  changedHolder: PropTypes.object.isRequired,
  collapsedHolder: PropTypes.array.isRequired,
  toggleHolder: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  account: PropTypes.object.isRequired,
  existsMainHolder: PropTypes.bool.isRequired,
  handleDeleteHolder: PropTypes.func.isRequired,
};

export default HoldersForm;
